export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1920w.4e7aeca9.png";